import { ReactNode } from 'react';

import { useLocation } from 'react-router';

import { ErrorBoundary } from 'shared/base';

export function RouterErrorBoundary({ children }: { children: ReactNode }) {
  const location = useLocation();

  return <ErrorBoundary pathname={location.pathname}>{children}</ErrorBoundary>;
}
